<!-- The Timeline -->
<app-user [user]="user"></app-user>
<mat-grid-list cols="1" rowHeight="500px">
  <mat-grid-tile>
    <mat-progress-spinner
      *ngIf="!languageData.length"
      mode="indeterminate"
    ></mat-progress-spinner>
    <app-pie
      *ngIf="languageData.length"
      id="timeline"
      [data]="languageData"
    ></app-pie
  ></mat-grid-tile>
</mat-grid-list>
<div class="container">
  <ul *ngIf="projects" class="timeline">
    <!-- Item 1 -->
    <app-flag
      *ngFor="let project of projects; let i = index"
      [project]="project"
      [direction]="i % 2 === 0 ? 'direction-r' : 'direction-l'"
    ></app-flag>
  </ul>
</div>
<router-outlet></router-outlet>
